import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ViewSlabsService } from './view-slabs.service';
import { Table, Pagination, TableActions, TableAction, TableData, TableDataTypes } from '../shared/types';
import { SharedService } from '../shared/shared.service';
import { LoaderService } from '../loader.service';
import { ToasterService } from '../toaster.service';
import Utils from 'src/app/utils/utils';
import { AuthzAccessHintService } from '../shared/authz-access-hint/authz-access-hint.service';
var ViewSlabsComponent = /** @class */ (function () {
    function ViewSlabsComponent(viewSlabService, sharedService, loaderService, router, route, toasterService, authzAccessHintService) {
        this.viewSlabService = viewSlabService;
        this.sharedService = sharedService;
        this.loaderService = loaderService;
        this.router = router;
        this.route = route;
        this.toasterService = toasterService;
        this.authzAccessHintService = authzAccessHintService;
        this.authzAccessHint = null;
        this.limit = 15;
        this.gotData = false;
        this.offset = 0;
        this.dataLoaded = false;
        this.tableLoaded = false;
        this.cities = [];
        this.services = [];
        this.shifts = [];
        this.filterComponents = [];
        this.cityMap = {};
        this.serviceMap = {};
        this.filterParams = {};
        this.currentFilters = {}; // Track all current filter selections
        this.showFilters = false;
        this.earningModelOptions = [];
        this.defineTable();
    }
    ViewSlabsComponent.prototype.defineTable = function () {
        this.table = new Table({
            headers: {
                active: 'Status',
                cities: 'City',
                shift: 'Shift Name',
                serviceTypes: 'Service',
                startDate: 'Start Date',
                createdBy: 'Created By',
                createdDate: 'Created Date',
                isFallbackSlab: 'Fallback Slab',
                poolConfig: 'Pool Configuration',
                action: 'Action',
            },
            sortableColumnKeys: [],
            pagination: new Pagination(0, 15, 10, [15, 20]),
        });
        this.tableLoaded = true;
    };
    ViewSlabsComponent.prototype.fetchTableData = function () {
        var _this = this;
        this.loaderService.openLoading();
        this.viewSlabService.fetchSlabData(this.buildPayload()).subscribe(function (res) {
            var slabs = res && res.slabs ? res.slabs : [];
            var pageNo = _this.table.pagination.pageNo;
            var perPage = _this.table.pagination.perPage;
            if (!slabs.length && pageNo > 0) {
                _this.table.pagination.count = pageNo * perPage;
                _this.table.pagination.pageNo--;
                return _this.fetchTableData();
            }
            _this.table.data = slabs.map(_this.mapSlabToTableRow.bind(_this));
            var totalSlabCount = res != null && res.count != null ? Number(res.count) : Number.NaN;
            _this.table.pagination.count = totalSlabCount;
            _this.dataLoaded = true;
            _this.loaderService.closeLoading();
        }, function () { return _this.loaderService.closeLoading(); });
    };
    ViewSlabsComponent.prototype.buildPayload = function () {
        return {
            limit: this.table.pagination.perPage,
            offset: this.table.pagination.pageNo * this.table.pagination.perPage,
            filters: tslib_1.__assign({}, this.filterParams),
        };
    };
    ViewSlabsComponent.prototype.mapSlabToTableRow = function (slab) {
        var cities = slab.cities || [];
        var shift = Array.isArray(slab.shift) ? slab.shift : [];
        var serviceNames = Array.isArray(slab.serviceNames) ? slab.serviceNames : [];
        var poolConfig = Utils.formatPoolConfigFromSlab(slab);
        return Object.assign({}, slab, {
            cities: cities.join(', '),
            shift: shift.join(', '),
            serviceTypes: serviceNames.join(', '),
            poolConfig: poolConfig,
            action: this.createAction(),
        });
    };
    ViewSlabsComponent.prototype.fetchAllCities = function () {
        var _this = this;
        return this.sharedService.fetchCities().toPromise().then(function (res) {
            var cities = Array.isArray(res && res.data && res.data.cities) ? res.data.cities : [];
            _this.cities = cities.map(function (city) { return city.displayName; });
            _this.patchFilterComponent('slab-city', { values: _this.cities });
            for (var _i = 0, cities_1 = cities; _i < cities_1.length; _i++) {
                var city = cities_1[_i];
                if (city) {
                    _this.cityMap[city.displayName] = city._id;
                }
            }
        }).catch(function () { return undefined; });
    };
    ViewSlabsComponent.prototype.fetchServices = function (city) {
        var _this = this;
        this.services = [];
        if (!city || city.length === 0) {
            this.patchFilterComponent('slab-services', { values: this.services });
            return Promise.resolve();
        }
        var requests = city.filter(Boolean).map(function (cty) {
            var cityId = _this.cityMap[cty];
            if (!cityId) {
                return Promise.resolve();
            }
            return _this.sharedService.fetchServices(cityId).toPromise().then(function (res) {
                for (var service in res.data) {
                    if (_this.services.indexOf(res.data[service].service.name) === -1) {
                        _this.services.push(res.data[service].service.name);
                    }
                }
                for (var service in res.data) {
                    if (res.data[service].service) {
                        _this.serviceMap[res.data[service].service.name] = res.data[service]._id;
                    }
                }
            }).catch(function () { return undefined; });
        });
        return Promise.all(requests).then(function () {
            _this.patchFilterComponent('slab-services', { values: _this.services });
        });
    };
    ViewSlabsComponent.prototype.fetchShifts = function (city) {
        var _this = this;
        this.shifts = [];
        if (city.length === 0) {
            this.patchFilterComponent('slab-shifts', { values: [] });
        }
        for (var _i = 0, city_1 = city; _i < city_1.length; _i++) {
            var cty = city_1[_i];
            if (cty) {
                this.sharedService.fetchShifts(cty).subscribe(function (res) {
                    var _a;
                    (_a = _this.shifts).push.apply(_a, res.data);
                    _this.patchFilterComponent('slab-shifts', { values: _this.shifts });
                });
            }
        }
    };
    ViewSlabsComponent.prototype.createAction = function () {
        var _this = this;
        return new TableData({
            actions: new TableActions([
                new TableAction({
                    onClick: function (data) {
                        _this.onViewSlab(data);
                    },
                    text: 'View'
                }),
                new TableAction({
                    onClick: function (data) {
                        _this.onDuplicateSlab(_this.getSlabId(data));
                    },
                    text: 'Duplicate'
                })
            ]),
            type: TableDataTypes.ACTION
        });
    };
    ViewSlabsComponent.prototype.getSlabId = function (row) {
        return row && row.id ? row.id : '';
    };
    ViewSlabsComponent.prototype.onViewSlab = function (row) {
        var slabId = this.getSlabId(row);
        if (!slabId) {
            return;
        }
        var url = this.router.serializeUrl(this.router.createUrlTree(['/slab/view', slabId]));
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    ViewSlabsComponent.prototype.onDuplicateSlab = function (slabId) {
        if (environment.isDuplicateSlabFlowEnabledInPayrollDash) {
            var url = this.router.serializeUrl(this.router.createUrlTree(['/slab/duplicate', slabId]));
            window.open(url, '_blank', 'noopener,noreferrer');
        }
        else {
            var url = '/payroll/duplicateSlab/' + slabId;
            this.sharedService.redirectToDashbaord(url);
        }
    };
    ViewSlabsComponent.prototype.filterToggle = function () {
        this.showFilters = !this.showFilters;
    };
    ViewSlabsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAccessHint();
        // Initialize currentFilters first, before components emit their defaults
        this.currentFilters = {
            'slab-status': 'Both',
            'slab-fallback': 'All'
        };
        // call city api, assign names to cities []
        this.filterComponents = [
            {
                type: 'searchable-dropdown',
                title: 'City',
                values: this.cities,
                default: '',
                key: 'slab-city'
            },
            {
                type: 'searchable-dropdown',
                title: 'Services',
                values: this.services,
                default: '',
                key: 'slab-services'
            },
            {
                type: 'searchable-dropdown',
                title: 'Shifts',
                values: this.shifts,
                default: '',
                key: 'slab-shifts'
            },
            {
                type: 'calendar',
                title: '',
                values: [],
                default: '',
                key: 'slab-dates'
            },
            // {
            //   type : 'single-searchable-dropdown',
            //   title : 'Type',
            //   values : ['cm', 'order', 'distance'],
            //   default : '',
            //   key: 'slab-type'
            // },
            {
                type: 'searchable-dropdown',
                title: 'Earning Model',
                values: this.earningModelOptions,
                default: '',
                key: 'slab-earning-model'
            },
            {
                type: 'radio-button',
                title: 'Status',
                values: ['Both', 'Active', 'Inactive'],
                default: 'Both',
                name: 'status-radio',
                key: 'slab-status'
            },
            {
                type: 'radio-button',
                title: 'Fallback Slab',
                values: ['All', 'Fallback Only'],
                default: 'All',
                name: 'fallback-slab-radio',
                key: 'slab-fallback'
            }
        ];
        this.applyRouteQueryParamsToFilters();
        this.fetchAllCities()
            .then(function () { return _this.applyCityServiceQueryParams(); })
            .then(function () {
            _this.rebuildFilterParamsFromCurrentFilters();
            _this.fetchTableData();
        });
        this.sharedService.fetchDashboardConfig().subscribe(function (res) {
            var dashboardConfig = _this.sharedService.parseDashboardConfigResponse(res);
            _this.earningModelOptions = _this.sharedService.collectAllEarningModelsFromDashboardConfig(dashboardConfig);
            _this.filterComponents = _this.filterComponents.map(function (node) {
                if (node.key === 'slab-earning-model') {
                    var merged = (_this.earningModelOptions || []).slice();
                    var init = node.initialSelected && node.initialSelected[0];
                    if (init && merged.indexOf(init) === -1) {
                        merged.unshift(init);
                    }
                    node.values = merged;
                }
                return node;
            });
        });
    };
    ViewSlabsComponent.prototype.loadAccessHint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.authzAccessHintService.getAccessHintData('slab')];
                    case 1:
                        _a.authzAccessHint = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ViewSlabsComponent.prototype.patchFilterComponent = function (key, patch) {
        this.filterComponents = this.filterComponents.map(function (node) {
            if (!node || node.key !== key) {
                return node;
            }
            return tslib_1.__assign({}, node, patch);
        });
    };
    ViewSlabsComponent.prototype.refreshFilterComponents = function () {
        // New object refs so SearchableDropdown re-reads initialSelected.
        this.filterComponents = this.filterComponents.map(function (node) { return (tslib_1.__assign({}, node)); });
    };
    ViewSlabsComponent.prototype.applyRouteQueryParamsToFilters = function () {
        var q = this.route.snapshot.queryParamMap;
        var shift = (q.get('shift') || '').trim();
        var earningModel = (q.get('earningModel') || '').trim();
        if (!shift && !earningModel) {
            return;
        }
        if (shift) {
            this.currentFilters['slab-shifts'] = [shift];
            var existing = this.filterComponents.find(function (node) { return node.key === 'slab-shifts'; });
            var vals = Array.isArray(existing && existing.values) ? existing.values.slice() : [];
            if (vals.indexOf(shift) === -1) {
                vals.unshift(shift);
            }
            this.patchFilterComponent('slab-shifts', {
                values: vals,
                initialSelected: [shift]
            });
            if (this.shifts.indexOf(shift) === -1) {
                this.shifts = [shift].concat(this.shifts);
            }
        }
        if (earningModel) {
            this.currentFilters['slab-earning-model'] = [earningModel];
            var existing = this.filterComponents.find(function (node) { return node.key === 'slab-earning-model'; });
            var vals = Array.isArray(existing && existing.values) ? existing.values.slice() : [];
            if (vals.indexOf(earningModel) === -1) {
                vals.unshift(earningModel);
            }
            this.patchFilterComponent('slab-earning-model', {
                values: vals,
                initialSelected: [earningModel]
            });
            if (this.earningModelOptions.indexOf(earningModel) === -1) {
                this.earningModelOptions = [earningModel].concat(this.earningModelOptions);
            }
        }
        this.showFilters = true;
    };
    // Prefill city + service filters from CSCC
    ViewSlabsComponent.prototype.applyCityServiceQueryParams = function () {
        var _this = this;
        var q = this.route.snapshot.queryParamMap;
        var cityId = (q.get('city') || '').trim();
        var serviceTypes = (q.get('serviceTypes') || '')
            .split(',')
            .map(function (s) { return s.trim(); })
            .filter(Boolean);
        // CSCC sends city id; resolve display name for the name-keyed filter UI.
        var resolvedCityName = '';
        if (cityId) {
            var match = Object.keys(this.cityMap).find(function (name) { return String(_this.cityMap[name]) === String(cityId); });
            resolvedCityName = match || '';
        }
        if (!resolvedCityName && !serviceTypes.length) {
            return Promise.resolve();
        }
        if (resolvedCityName) {
            this.currentFilters['slab-city'] = [resolvedCityName];
            this.patchFilterComponent('slab-city', {
                initialSelected: [resolvedCityName],
                default: [resolvedCityName]
            });
            this.fetchShifts([resolvedCityName]);
        }
        var citiesForServices = resolvedCityName ? [resolvedCityName] : [];
        return this.fetchServices(citiesForServices).then(function () {
            // CSCC sends serviceDetailId(s) via serviceTypes; resolve names from serviceMap.
            var serviceNames = [];
            if (serviceTypes.length) {
                Object.keys(_this.serviceMap).forEach(function (name) {
                    if (serviceTypes.indexOf(String(_this.serviceMap[name])) !== -1
                        && serviceNames.indexOf(name) === -1) {
                        serviceNames.push(name);
                    }
                });
            }
            if (serviceNames.length) {
                _this.currentFilters['slab-services'] = serviceNames;
                var existing = _this.filterComponents.find(function (node) { return node.key === 'slab-services'; });
                var vals_1 = Array.isArray(existing && existing.values) ? existing.values.slice() : [];
                serviceNames.forEach(function (name) {
                    if (vals_1.indexOf(name) === -1) {
                        vals_1.unshift(name);
                    }
                });
                _this.patchFilterComponent('slab-services', {
                    values: vals_1,
                    initialSelected: serviceNames.slice(),
                    default: serviceNames.slice()
                });
            }
            if (resolvedCityName || serviceNames.length) {
                _this.refreshFilterComponents();
                _this.showFilters = true;
            }
        });
    };
    ViewSlabsComponent.prototype.rebuildFilterParamsFromCurrentFilters = function () {
        var _this = this;
        var filters = {};
        var allFilters = this.currentFilters;
        if (allFilters['slab-status'] && allFilters['slab-status'] !== 'Both') {
            filters.active = allFilters['slab-status'] === 'Active';
        }
        if (allFilters['slab-fallback'] === 'Fallback Only') {
            filters.isFallbackSlab = true;
        }
        if (allFilters['slab-earning-model'] && allFilters['slab-earning-model'].length > 0) {
            filters.earningModel = allFilters['slab-earning-model'];
        }
        if (allFilters['slab-dates'] && allFilters['slab-dates'].length > 0) {
            if (allFilters['slab-dates'][0]) {
                filters.startDate = allFilters['slab-dates'][0];
            }
            if (allFilters['slab-dates'][1]) {
                filters.startDateLte = allFilters['slab-dates'][1];
            }
        }
        if (allFilters['slab-shifts'] && allFilters['slab-shifts'].length > 0) {
            filters.shifts = allFilters['slab-shifts'];
        }
        if (allFilters['slab-services'] && allFilters['slab-services'].length > 0) {
            filters.serviceDetailIds = allFilters['slab-services'].map(function (service) { return _this.serviceMap[service]; });
        }
        if (allFilters['slab-city'] && allFilters['slab-city'].length > 0) {
            filters.cities = allFilters['slab-city'];
        }
        this.filterParams = filters;
    };
    ViewSlabsComponent.prototype.listen = function ($evt) {
        Object.assign(this.currentFilters, $evt);
        if ('slab-city' in $evt) {
            var selectedCities = $evt['slab-city'];
            if (Array.isArray(selectedCities) && selectedCities.length === 0) {
                this.services = [];
                this.shifts = [];
            }
            if (Array.isArray(selectedCities)) {
                this.fetchServices(selectedCities);
                this.fetchShifts(selectedCities);
            }
        }
    };
    ViewSlabsComponent.prototype.searchByShift = function () {
        this.filterParams = {
            shift_regex: this.shiftSearch,
        };
        this.fetchTableData();
    };
    ViewSlabsComponent.prototype.applyFilters = function ($event) {
        console.log('Got these filters : ', $event);
        this.table.pagination.setPageNoToZero();
        var filters = $event;
        Object.assign(this.currentFilters, filters);
        this.rebuildFilterParamsFromCurrentFilters();
        this.fetchTableData();
    };
    return ViewSlabsComponent;
}());
export { ViewSlabsComponent };
